<template>
  <div class="cta-pos">
    <img
      :src="imgSrc"
      alt="cta-pos-event-tips"
    >
    <div class="cta-pos__wrap">
      <div class="cta-pos__wrap__text">
        Cek Agen/POS yang tersedia <span>pengiriman internasional!</span>
      </div>
      <div class="cta-pos__wrap__btn">
        <Button
          id="cta_pos_event_tips"
          text="Cek disini"
          @click="goToPOS"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/new-button/Button";
import mixinMobile from "@/misc/mixinMobile";
import Cta from "@/assets/agent-location/cta_pos_interpack_long.webp";
import CtaMobile from "@/assets/agent-location/cta_pos_interpack_mobile.webp";

export default {
  name: "POSSectionEventTips",
  components: { Button },
  mixins: [mixinMobile],
  data() {
    return {
      Cta,
      CtaMobile,
    }
  },
  computed: {
    imgSrc() {
      return this.windowWidth <= 599
        ? this.CtaMobile
        : this.Cta;
    },
  },
  methods: {
    goToPOS() {
      this.$router.push('/lokasi-agen/pengiriman-internasional');
      window.scrollTo(0, 0);
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/style.scss";

.cta-pos {
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
  max-width: 1152px;
  margin: 7rem auto 0;

  @include for-size(mobile) {
    align-items: center;
    max-width: 88%;
    margin: 2rem auto 0;
  }

  @include for-size(mobile-landscape) {
    max-width: 88%;
    margin: 2rem auto 0;
  }

  @include for-size(tablet-portrait) {
    max-width: 88%;
    margin: 2rem auto 0;
  }

  @media (min-width: 1024px) and (max-width: 1240px) {
    max-width: 88%;
    margin: 2rem auto 0;
  }

  &__wrap {
    display: flex;
    justify-content: center;
    flex-direction: column;
    position: absolute;
    margin: auto 0;
    padding-left: 5%;

    @include for-size(mobile) {
      top: 5%;
      padding-left: unset;
    }
    
    &__text {
      font-size: 34px;
      font-weight: 700;
      line-height: 42px;
      color: black;
      margin-bottom: 20px;
      letter-spacing: -0.02em;

      @include for-size(mobile) {
        font-size: 20px;
        line-height: 25px;
        margin-bottom: 10px;
      }

      @include for-size(mobile-landscape) {
        font-size: 20px;
        line-height: 25px;
        margin-bottom: 10px;
      }

      @include for-size(tablet-portrait) {
        font-size: 20px;
        line-height: 25px;
        margin-bottom: 10px;
      }

      span::before {
        content: "\A";
        white-space: pre;
      }
    }

    &__btn {
      width: 444px;
      height: 40px;

      @include for-size(mobile) {
        width: 296px;
      }

      @include for-size(mobile-landscape) {
        width: 296px;
      }

      @include for-size(tablet-portrait) {
        width: 296px;
      }
    }
  }
}
</style>
